import React, { PropTypes } from 'react';
import { Navbar } from 'react-bootstrap';
import { Link, IndexLink } from 'react-router';

class PurchaseReturn extends React.Component {
   render() {
      return (
         <div className="PurchaseReturn" >
            <Navbar>
               <Navbar.Header>
                  <Navbar.Brand>
                     <Link to="/purchaseReturn/" activeStyle={{ color: 'red' }} >PurchaseReturn</Link>
                  </Navbar.Brand>
               </Navbar.Header>
               <ul className="nav navbar-nav" >
                  <li>
                     <IndexLink to="/purchaseReturn/" activeStyle={{ color: 'red' }} >All</IndexLink>
                  </li>
                  <li>
                     <Link to="/purchaseReturn/newPurchaseReturn" activeStyle={{ color: 'red' }} >New</Link>
                  </li>
               </ul>
            </Navbar>
            {this.props.children}
         </div>
      );
   }
}

PurchaseReturn.propTypes = {
   children: PropTypes.object
};

export default PurchaseReturn;



/** WEBPACK FOOTER **
 ** ./src/components/InvoiceManagement/PurchaseReturn/PurchaseReturn.js
 **/